import { Component, Input } from '@angular/core';
import { Patient } from '../patient';

@Component({
  selector: 'mc-patient-header',
  templateUrl: './patient-header.component.html',
  styleUrls: ['./patient-header.component.scss']
})
export class PatientHeaderComponent {

  @Input() public patient: Patient;
  @Input() public showPhones: boolean = false;
  @Input() public schedulingTypeName: string;
  @Input() public appointmentTypeName: string;

  constructor() { }

  getPatientAge(): string {
    return Patient.getCurrentAge(this.patient);
  }
}
